export const IS_PRODUCTION = location.host === 'jobian.com'